<script lang="ts">
  /**
   * Sign-in is deliberately a plain link, not a fetch: the OAuth flow is a
   * browser redirect and must not be intercepted by JS.
   */
  const returnTo = encodeURIComponent(location.hash || '#/today');
</script>

<div class="wrap">
  <div class="card stack">
    <h1>Timesheet</h1>
    <p class="muted">
      Log consulting hours straight into Google Sheets. You sign in once — the session is kept
      alive for you, so logging a session is two taps.
    </p>
    <a class="cta" href="/auth/login?returnTo=/{returnTo}">Sign in with Google</a>
    <p class="fine muted">
      Uses the <code>drive.file</code> scope, so the app can only ever see spreadsheets it created
      or that you explicitly pick.
    </p>
  </div>
</div>

<style>
  .wrap {
    display: grid;
    place-items: center;
    min-height: 60dvh;
  }

  .card {
    max-width: 26rem;
    text-align: center;
  }

  .cta {
    background: var(--accent);
    color: var(--accent-fg);
    text-decoration: none;
    font-weight: 650;
    border-radius: var(--radius);
    padding: 0.8rem 1.2rem;
  }

  .fine {
    font-size: 0.78rem;
  }

  code {
    background: var(--surface-2);
    padding: 0.05rem 0.3rem;
    border-radius: 4px;
    font-size: 0.9em;
  }
</style>
